import * as $ from 'jquery';

(function () {
    $(function () {
        $('.js-reset-categories').on('click', function (): void {
            $('.js-category').show();
            $('.js-filter, .js-reset-categories').find('button').removeClass('active');
            $(this).find('button').addClass('active');
        });

        $('.js-filter').on('click', function (event : JQuery.Event): void {
            $('.js-filter, .js-reset-categories').find('button').removeClass('active');
            const id = $(this).attr('data-category-id');
            $('.js-category').hide();
            $('.js-category[data-category-id=' + id + ']').show();
            $(this).find('button').addClass('active');
        });
    });
})();



// WEBPACK FOOTER //
// ./assets/typescript/events.ts